export default "__VITE_ASSET__CyeK01m5__"